/**
 * External dependencies
 */
import React, { useState, useMemo } from 'react';
import { connect } from 'react-redux';
import { Box, Stack, Text, Heading } from '@towersystems/towersystems-design-system';

/**
 * Internal dependencies
 */
import Modal from 'components/modal';
import { createCloseModalAction } from 'state/ui/actions';
import { isModalVisible } from 'state/ui/selectors';
import Card from 'components/card';
import AddPaymentMethodForm from 'blocks/add-payment-method-form';
import Button from 'components/button';
import { requestPaymentMethods } from 'state/payment-methods/actions';
import { successNotice } from 'state/notices/actions';

/**
 * Style dependencies
 */
import './styles.scss';

const AddPaymentMethodModal = ({ isVisible, close, ...props }) => {
    const [requesting, setRequesting] = useState(false);
    const [isReady, setIsReady] = useState(false);

    const form = (
        <AddPaymentMethodForm
            beforeSubmit={() => setRequesting(true)}
            afterSubmit={() => setRequesting(false)}
            afterReady={() => setIsReady(true)}
            afterSuccessSubmit={() => {
                close();
                props.requestPaymentMethods();
                props.successNotice('Payment method created');
            }}
        />
    );

    return (
        <Modal className='add-payment-method-modal' close={close} isVisible={isVisible} header={false}>
            <Box
                padding='xxlarge'
                display='flex'
                flexDirection='column'
                justifyContent='spaceBetween'
                style={{ height: '100%' }}
            >
                <Box padding='large'>
                    <Box marginBottom='large'>
                        <Heading level='3'>Add new card</Heading>
                        <Text size='small'>
                            Any outstanding bills will automatically be charged once a valid payment method has been
                            saved.
                        </Text>
                    </Box>
                    {form}
                </Box>
                <Box padding='large' alignItems='center' justifyContent='center'>
                    <Button
                        disabled={requesting || !isReady}
                        className='add-payment-method-btn'
                        form='add-payment-method-form'
                        type='submit'
                        primary
                    >
                        Pay & Add new card
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default connect(
    (state) => ({
        isVisible: isModalVisible('AddPaymentMethodModal')(state),
    }),
    {
        close: createCloseModalAction('AddPaymentMethodModal'),
        requestPaymentMethods,
        successNotice,
    },
)(AddPaymentMethodModal);
